import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-cable-route-menu",
  imports: [
    AddButtonComponent,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    UiKitModule,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./floorplan-cable-route-menu.component.html",
  styleUrl: "./floorplan-cable-route-menu.component.scss",
})
export class FloorplanCableRouteMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;

  protected readonly tooltipTextAddCableRoute: string = $localize`:@@floorplan.button.addCableRoute:Neue Kabeltrasse hinzufügen`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  addCableRoute() {
    this.floorplanService.addCableRoute();
  }

  dragCableRoute() {
    this.dragDropService.setDragged({ type: DraggedItemType.CABLE_ROUTE });
  }

  protected updateCableRoutesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateCableRoutesItemTextVisibility(visible);
  }
}
